import React, { PureComponent } from "react";
import FJPageHeader from "fj-components/FJPageHeader";
import FJFixedLayout from 'fj-components/FJFixedLayout'
import styles from './FJResourcesTransitionList.module.less'
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJLocalStore from "../../../store/FJLocalStore";
import FJResourcesTransitionCommon from "./FJResourcesTransitionCommon";

class FJResourcesTransitionList extends PureComponent {

	_getCollectionList = () => {
		let {allResources, seeAllText, classes} = this.props;
		let items = [];
		for (let i in allResources) {
			if (allResources.hasOwnProperty(i)) {
				let item = allResources[i];
				items.push(
					<FJPageHeader key={item.category}
					              title={FJLocalStore._(item.category)}
					              id={i}
					              seeAllText={seeAllText}
					              classes={classes.pageHeaderClasses}
												hasSeeAll={false}
					>
						{this._renderList(item.items, this.props.isShow)}
					</FJPageHeader>
				);
			}
		}

		return items;
	}

	_renderList = (list, active) => {
		let {
			onAddClick,
			onHandleClick,
			resourceViewInfo,
			classes,
			onMediaDrag,
			config,
			allTooltip,
			toggleTooltip,
			oneTooltip,
		} = this.props;


		let {
			width,
			height,
			space,
			marginBottom
		} = resourceViewInfo;

		let {
			activeColor,
			addIconToolTip
		} = config;
		return <FJFixedLayout
			basicWidth={width}
			space={space}
			active={active}
			render={(itemWidth, space, column) => {
				let itemHeight = height;
				let items = [];
				list.forEach((item, index) => {
					items.push(
						<FJResourcesTransitionCommon
							key={item.name}
							id={item.name}
							width={itemWidth}
							height={itemHeight}
							marginRight={(index + 1) % column === 0 ? 0 : space}
							marginBottom={marginBottom}
							name={FJLocalStore._(item.label)}
							hasName={true}
							type={item.label}
							hasAddBtn
							onAddClick={onAddClick}
							selectMedia={onHandleClick}
							classes={classes.itemClasses}
							activeColor={activeColor}
							onMediaDrag={onMediaDrag}
							addIconToolTip={addIconToolTip}
							allTooltip={allTooltip}
							toggleTooltip={toggleTooltip}
							oneTooltip={oneTooltip}
							transitionName={item.name}
						/>
					)
				});
				return items;
			}}
		/>
	}


	render() {
		let {classes} = this.props
		return(
			<div className={styles.list_box}>
				<FJCustomScroll classes={classes.textMoreClasses}>
					{this._getCollectionList()}
				</FJCustomScroll>
			</div>
		)
	}

}


export default FJResourcesTransitionList;